import * as React from "react";

function SvgDwc(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <defs>
        <text
          id="dwc_svg__a"
          x={179.52}
          y={200.33}
          fontSize={13}
          fontFamily="Alegreya"
          fontWeight={700}
          fontStyle="normal"
          letterSpacing={0}
          alignmentBaseline="before-edge"
          transform="translate(-163.74 -194.847)"
          style={{
            lineHeight: "100%",
          }}
          xmlSpace="preserve"
          dominantBaseline="text-before-edge"
        >
          <tspan x={179.52} dy="0em" alignmentBaseline="before-edge" />
        </text>
        <text
          id="dwc_svg__b"
          x={179.52}
          y={200.33}
          fontSize={13}
          fontFamily="Alegreya"
          fontWeight={700}
          fontStyle="normal"
          letterSpacing={0}
          alignmentBaseline="before-edge"
          transform="translate(-163.74 -195.165)"
          style={{
            lineHeight: "100%",
          }}
          xmlSpace="preserve"
          dominantBaseline="text-before-edge"
        >
          <tspan x={179.52} dy="0em" alignmentBaseline="before-edge">
            {"C"}
          </tspan>
        </text>
        <text
          id="dwc_svg__c"
          x={179.52}
          y={200.33}
          fontSize={13}
          fontFamily="Alegreya"
          fontWeight={700}
          fontStyle="normal"
          letterSpacing={0}
          alignmentBaseline="before-edge"
          transform="translate(-163.74 -194.847)"
          style={{
            lineHeight: "100%",
          }}
          xmlSpace="preserve"
          dominantBaseline="text-before-edge"
        >
          <tspan x={179.52} dy="0em" alignmentBaseline="before-edge" />
        </text>
        <text
          id="dwc_svg__d"
          x={179.52}
          y={199.33}
          fontSize={13}
          fontFamily="Alegreya"
          fontWeight={700}
          fontStyle="normal"
          letterSpacing={0}
          alignmentBaseline="before-edge"
          transform="translate(-173.963 -198.075)"
          style={{
            lineHeight: "100%",
          }}
          xmlSpace="preserve"
          dominantBaseline="text-before-edge"
        >
          <tspan x={179.52} dy="0em" alignmentBaseline="before-edge" />
        </text>
        <text
          id="dwc_svg__e"
          x={179.52}
          y={199.33}
          fontSize={13}
          fontFamily="Alegreya"
          fontWeight={700}
          fontStyle="normal"
          letterSpacing={0}
          alignmentBaseline="before-edge"
          transform="translate(-173.963 -198.075)"
          style={{
            lineHeight: "100%",
          }}
          xmlSpace="preserve"
          dominantBaseline="text-before-edge"
        >
          <tspan x={179.52} dy="0em" alignmentBaseline="before-edge">
            {"W"}
          </tspan>
        </text>
        <text
          id="dwc_svg__f"
          x={179.52}
          y={199.33}
          fontSize={13}
          fontFamily="Alegreya"
          fontWeight={700}
          fontStyle="normal"
          letterSpacing={0}
          alignmentBaseline="before-edge"
          transform="translate(-173.963 -198.075)"
          style={{
            lineHeight: "100%",
          }}
          xmlSpace="preserve"
          dominantBaseline="text-before-edge"
        >
          <tspan x={179.52} dy="0em" alignmentBaseline="before-edge" />
        </text>
        <text
          id="dwc_svg__g"
          x={179.52}
          y={205.33}
          fontSize={10}
          fontFamily="Alegreya"
          fontWeight={700}
          fontStyle="normal"
          letterSpacing={0}
          alignmentBaseline="before-edge"
          transform="translate(-179.294 -196.946)"
          style={{
            lineHeight: "100%",
          }}
          xmlSpace="preserve"
          dominantBaseline="text-before-edge"
        >
          <tspan x={179.52} dy="0em" alignmentBaseline="before-edge" />
        </text>
        <text
          id="dwc_svg__h"
          x={179.52}
          y={205.33}
          fontSize={10}
          fontFamily="Alegreya"
          fontWeight={700}
          fontStyle="normal"
          letterSpacing={0}
          alignmentBaseline="before-edge"
          transform="translate(-179.29 -200.065)"
          style={{
            lineHeight: "100%",
          }}
          xmlSpace="preserve"
          dominantBaseline="text-before-edge"
        >
          <tspan x={179.52} dy="0em" alignmentBaseline="before-edge">
            {"D"}
          </tspan>
        </text>
        <text
          id="dwc_svg__i"
          x={179.52}
          y={205.33}
          fontSize={10}
          fontFamily="Alegreya"
          fontWeight={700}
          fontStyle="normal"
          letterSpacing={0}
          alignmentBaseline="before-edge"
          transform="translate(-179.294 -196.946)"
          style={{
            lineHeight: "100%",
          }}
          xmlSpace="preserve"
          dominantBaseline="text-before-edge"
        >
          <tspan x={179.52} dy="0em" alignmentBaseline="before-edge" />
        </text>
      </defs>
      <use xlinkHref="#dwc_svg__a" />
      <use xlinkHref="#dwc_svg__b" />
      <use xlinkHref="#dwc_svg__c" fillOpacity={0} />
      <use xlinkHref="#dwc_svg__d" />
      <use xlinkHref="#dwc_svg__e" />
      <use xlinkHref="#dwc_svg__f" fillOpacity={0} />
      <use xlinkHref="#dwc_svg__g" />
      <use xlinkHref="#dwc_svg__h" />
      <use xlinkHref="#dwc_svg__i" fillOpacity={0} />
    </svg>
  );
}

export default SvgDwc;
